// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {App_context} from 'hola_app_context';
import React, {useEffect, Fragment, useContext} from 'react';
// @ts-ignore
import {get, set} from '/util/storage.js';
import {www_hola} from 'hola_opt';

export const Ga = ()=>{
    const {user} = useContext(App_context);
    useEffect(()=>{
        if (user && !get('signup_event') && www_hola.send_ga_events)
        {
            set('signup_event', true);
            try {
                (window as any).dataLayer.push({
                    event: www_hola.signup_success_event
                        || 'gtag.signup_success',
                });
            } catch {}
            if (www_hola.signup_ads_conversion)
            {
                try {
                    (window as any).gtag('event', 'conversion', {
                        send_to: 'AW-16555647232/vYnnCNbZxa0ZEIDCrNY9'
                    });
                } catch {}
            }
        }
    }, [user]);
    return <Fragment />;
};
